module.exports = __webpack_public_path__ + "img/p3.a91a26ce.png";